import Logger from '../util/Logger';
import _ from 'lodash';

const Roster = {

  /**
   * This field is not delivered back by the server
   * @param roster
   * @return {WebClientLocals}
   */
  getClientLocals (roster) {
    if (!roster) {
      Logger.assert('Missing roster');
    } else {
      return new WebClientLocals(roster);
    }
  },

  getTags (roster) {
    if (!roster) {
      Logger.assert('Missing roster');
    } else {
      return _.get(roster, 'tags');
    }
  },

  getUserInfo (roster) {
    if (!roster) {
      Logger.assert('Missing roster');
    } else {
      return _.get(roster, 'user_info');
    }
  }

};

class WebClientLocals {

  constructor (roster) {
    this.__roster = roster;
  }

  getId () {
    if (!this.__roster) {
      Logger.assert('Missing roster');
    } else {
      return _.get(this.__roster, 'id');
    }
  }

  getSize () {
    if (!this.__roster) {
      Logger.assert('Missing roster');
    } else {
      return Roster.getUserInfo(this.__roster).length || 0;
    }
  }
}

export default Roster;
